import { axiosInstance } from "../../utils";

const actions = {
  FETCH_GIFTS_REQUESTED: "FETCH_GIFTS_REQUESTED",
  FETCH_GIFTS_SUCCEEDED: "FETCH_GIFTS_SUCCEEDED",
  FETCH_GIFTS_FAILED: "FETCH_GIFTS_FAILED",

  FETCH_GIFT_REQUESTED: "FETCH_GIFT_REQUESTED",
  FETCH_GIFT_SUCCEEDED: "FETCH_GIFT_SUCCEEDED",
  FETCH_GIFT_FAILED: "FETCH_GIFT_FAILED",

  SEARCH_GIFT_REQUESTED: "SEARCH_GIFT_REQUESTED",
  SEARCH_GIFT_SUCCEEDED: "SEARCH_GIFT_SUCCEEDED",
  SEARCH_GIFT_FAILED: "SEARCH_GIFT_FAILED",

  DELETE_GIFT_REQUESTED: "DELETE_GIFT_REQUESTED",
  DELETE_GIFT_SUCCEEDED: "DELETE_GIFT_SUCCEEDED",
  DELETE_GIFT_FAILED: "DELETE_GIFT_FAILED",

  fetchGifts: (id = undefined) => {
    return {
      type: actions.SEARCH_GIFT_REQUESTED,
      payload: id,
    };
  },

  fetchGift: (id = undefined) => {
    return {
      type: actions.FETCH_GIFT_REQUESTED,
      payload: id,
    };
  },

  removeGift: (id = undefined) => {
    return {
      type: actions.DELETE_GIFT_REQUESTED,
      payload: id,
    };
  },

  getGifts: async (params = undefined) => {
    const url = `gifts`;
    try {
      const gifts = await axiosInstance.get(url, { params });
      return gifts.data;
    } catch (error) {
      throw error;
    }
  },

  searchGifts: async (params = {}) => {
    const url = `gifts`;

    // q param is required
    if (!params.q) params.q = "";

    try {
      const gifts = await axiosInstance.get(url, { params });
      return gifts.data;
    } catch (error) {
      throw error;
    }
  },

  getGift: async (giftId = undefined) => {
    const url = `gifts/` + giftId;

    try {
      const gift = await axiosInstance.get(url);
      return gift.data;
    } catch (error) {
      throw error;
    }
  },

  deleteGift: async (id = undefined) => {
    const url = `gifts/` + id;

    try {
      const response = await axiosInstance.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
export default actions;
